import React from 'react'
import { Download01, File01, File02, Image01 } from '@untitled-ui/icons-react'

// Shared attachment row (matches the Workforce candidate-detail style): a
// file-type icon pill + name + optional meta, the whole row clickable. `onClick`
// typically opens a FileViewer. Used by the company + workforce attachment lists
// for a consistent look.

function fileType(name, mimeType) {
  const m = (mimeType || '').toLowerCase()
  const n = (name || '').toLowerCase()
  if (m.includes('pdf') || n.endsWith('.pdf')) return 'PDF'
  if (m.includes('png') || n.endsWith('.png')) return 'PNG'
  if (m.includes('jpeg') || m.includes('jpg') || /\.jpe?g$/.test(n)) return 'JPG'
  if (m.includes('gif') || n.endsWith('.gif')) return 'GIF'
  if (m.includes('msword') || m.includes('wordprocessingml') || /\.docx?$/.test(n)) return 'DOC'
  return 'FILE'
}

function typeIcon(type) {
  switch (type) {
    case 'PDF':
      return <File02 className="h-4 w-4 text-red-600" />
    case 'JPG':
    case 'PNG':
      return <Image01 className="h-4 w-4 text-blue-600" />
    case 'GIF':
      return <File01 className="h-4 w-4 text-purple-600" />
    case 'DOC':
      return <File02 className="h-4 w-4 text-sky-600" />
    default:
      return <File01 className="h-4 w-4 text-gray-600" />
  }
}

function pillColor(type) {
  switch (type) {
    case 'PDF':
      return 'bg-red-50 text-red-700'
    case 'JPG':
    case 'PNG':
      return 'bg-blue-50 text-blue-700'
    case 'GIF':
      return 'bg-purple-50 text-purple-700'
    case 'DOC':
      return 'bg-sky-50 text-sky-700'
    default:
      return 'bg-gray-50 text-gray-700'
  }
}

export default function AttachmentRow({ name, mimeType, meta, onClick, disabled = false, last = false }) {
  const type = fileType(name, mimeType)
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={!disabled ? `View ${name || 'document'}` : undefined}
      className={`group flex w-full items-center justify-between px-4 py-3 text-left transition-colors ${
        last ? '' : 'border-b border-gray-100'
      } ${disabled ? 'cursor-default' : 'cursor-pointer hover:bg-gray-50'}`}
    >
      <div className="flex min-w-0 items-center gap-3">
        <div className={`rounded-lg p-2 ${pillColor(type)}`}>{typeIcon(type)}</div>
        <span className="truncate text-sm font-medium text-gray-900">{name || '—'}</span>
      </div>
      <div className="flex shrink-0 items-center gap-3">
        {meta ? <span className="text-sm font-medium text-gray-500">{meta}</span> : null}
        {!disabled && <Download01 className="h-4 w-4 text-gray-300 group-hover:text-gray-500" />}
      </div>
    </button>
  )
}
